import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Getalldata,
  GetalldataLeadsWithPages,
  GetAllLeadsSearchAction,
} from '../Redux/Actions/UsersAction';

export const ClientHook = () => {
  const [userlogin, setuserlogin] = useState('');
  useEffect(() => {
    if (JSON.parse(localStorage.getItem('user')) != null) {
      setuserlogin(JSON.parse(localStorage.getItem('user')));
    }
  }, []);

  const dispatch = useDispatch();
  const [stagestorage, setstagestorage] = useState('');
  const [loading, setloading] = useState(true);
  const limit = 10000;

  // تحميل مرحلة التخزين عند بدء التحميل
  useEffect(() => {
    if (localStorage.getItem('stagestorage') != null) {
      setstagestorage(localStorage.getItem('stagestorage'));
    } else {
      setstagestorage('');
    }
  }, []);

  // جلب البيانات فور تحميل المكون وعند تغيير المرحلة
  useEffect(() => {
    const fetchData = async () => {
      setloading(true);
      try {
        if (stagestorage) {
          await dispatch(GetAllLeadsSearchAction(`stage=${stagestorage}`));
        } else {
          await dispatch(GetalldataLeadsWithPages(`limit=${limit}`));
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setloading(false);
      }
    };

    fetchData(); // جلب البيانات فورًا عند التحميل

    // يمكنك الاحتفاظ بفاصل التحديث إذا كنت بحاجته
    const interval = setInterval(fetchData, 180000); // كل 3 دقائق

    return () => clearInterval(interval);
  }, [stagestorage, dispatch]);

  const users = useSelector((state) => state.Allusers.Get_users);
  const pagecount = users?.pagination?.NumberOfPages ?? 1;

  const getpages = async (page) => {
    await dispatch(GetalldataLeadsWithPages(page, limit));
  };

  let allleads = [];
  let usersarray = Array.isArray(users?.data) ? users.data : [];

  if (usersarray) {
    allleads = usersarray.map((item) => ({
      _id: item._id,
      name: item.name,
      email: item.email,
      phone: item.phone,
      project: item.project ? item.project.name : '',
      sales: item.sales ? item.sales.name : null,
      notes: item.notes,
      Date: item.date,
      assign: item.assign,
      stage: item.stage ? item.stage.name : '',
      chanel: item.chanel ? item.chanel.name : '',
      communicationway: item.communicationway ? item.communicationway.name : null,
      leedtype: item.leedtype,
      budget: item.budget,
      stagedateupdated: item.stagedateupdated,
      createdAt: item.createdAt,
      updatedAt: item.updatedAt,
      developer: item.project?.developer || null,
    }));
  }

  return [usersarray, allleads, loading, pagecount, getpages];
};
